export { default } from './container'



// WEBPACK FOOTER //
// ./src/components/with-tenants/index.js